import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";

const BRAND_PRIMARY = "#4b36cc";

export function PublicHeader() {
  const { lang, setLang } = useLanguage();
  const [logoGifSrc, setLogoGifSrc] = useState<string | null>(null);

  useEffect(() => {
    setLogoGifSrc("/logo-rtg.gif.gif?v=5");
  }, []);

  return (
    <header className="bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 pt-4 pb-2 sm:pt-5 sm:pb-2.5 flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center shrink-0 transition-opacity hover:opacity-90 p-0 border-0 no-underline -ml-6 sm:-ml-8"
        >
          {logoGifSrc ? (
            <img
              key={logoGifSrc}
              src={logoGifSrc}
              alt="RTG"
              className="block h-6 w-auto max-h-7 sm:h-7 sm:max-h-9 object-contain border-0 outline-none shadow-none"
              style={{
                mixBlendMode: "darken",
                imageRendering: "crisp-edges",
              }}
              loading="eager"
              decoding="async"
            />
          ) : (
            <span
              className="h-10 w-10 flex items-center justify-center rounded-lg text-white text-sm font-bold shrink-0"
              style={{ backgroundColor: BRAND_PRIMARY }}
            >
              RTG
            </span>
          )}
        </Link>
        <div className="flex items-center gap-1 text-sm text-gray-600">
          {(["pt", "en", "es"] as const).map((l) => (
            <button
              key={l}
              onClick={() => setLang(l)}
              className={`px-2 py-1 rounded transition-colors ${
                lang === l
                  ? "text-[#3c3939] font-semibold"
                  : "hover:text-[#3c3939]"
              }`}
            >
              {l.toUpperCase()}
            </button>
          ))}
        </div>
      </div>
    </header>
  );
}
